import { render, staticRenderFns } from "./PrefrenceModule.vue?vue&type=template&id=ffbc197a&scoped=true"
import script from "./PrefrenceModule.vue?vue&type=script&lang=js"
export * from "./PrefrenceModule.vue?vue&type=script&lang=js"
import style0 from "./PrefrenceModule.vue?vue&type=style&index=0&id=ffbc197a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbc197a",
  null
  
)

export default component.exports